import { render, staticRenderFns } from "./IbTabs.vue?vue&type=template&id=c243cd94"
import script from "./IbTabs.vue?vue&type=script&lang=js"
export * from "./IbTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports